import * as Models from '../Models';

export const moveCaretAtEnd: Function = (e) => {
    const temp_value: string = e.target.value
    e.target.value = ''
    e.target.value = temp_value
}

export const comparisonOperators: Models.ComparisonOperatorField[] = [
    {
        key: 'lt',
        value: 'less than',
        fieldTypes: [Models.SearchSettingValueType.Integer, Models.SearchSettingValueType.Double, Models.SearchSettingValueType.DateTime],
        elementTypes: [],
        classAttribute: true
    },
    {
        key: 'gt',
        value: 'greater than',
        fieldTypes: [Models.SearchSettingValueType.Integer, Models.SearchSettingValueType.Double, Models.SearchSettingValueType.DateTime],
        elementTypes: [],
        classAttribute: true
    },
    {
        key: 'eq',
        value: 'is',
        fieldTypes: [Models.SearchSettingValueType.Integer, Models.SearchSettingValueType.Double, Models.SearchSettingValueType.String, Models.SearchSettingValueType.Boolean],
        elementTypes: [],
        classAttribute: true
    },
    {
        key: 'ne',
        value: 'is not',
        fieldTypes: [Models.SearchSettingValueType.Integer, Models.SearchSettingValueType.Double, Models.SearchSettingValueType.String],
        elementTypes: [],
        classAttribute: true
    },
    {
        key: 'between',
        value: 'is between',
        fieldTypes: [Models.SearchSettingValueType.Integer, Models.SearchSettingValueType.Double, Models.SearchSettingValueType.DateTime],
        elementTypes: [],
        classAttribute: true
    },
    {
        key: 'contains',
        value: 'contains',
        fieldTypes: [Models.SearchSettingValueType.String],
        elementTypes: [Models.SearchSettingElementType.TextWithOperators, Models.SearchSettingElementType.SelectWithOperators],
        classAttribute: true
    },
    {
        key: 'doesnotcontain',
        value: 'does not contain',
        fieldTypes: [Models.SearchSettingValueType.String],
        elementTypes: [Models.SearchSettingElementType.TextWithOperators],
        classAttribute: true
    },
    {
        key: 'startswith',
        value: 'starts with',
        fieldTypes: [Models.SearchSettingValueType.Integer, Models.SearchSettingValueType.Double, Models.SearchSettingValueType.DateTime],
        elementTypes: [Models.SearchSettingElementType.TextWithOperators, Models.SearchSettingElementType.SelectWithOperators],
        classAttribute: false
    },
    {
        key: 'doesnotstartwith',
        value: 'does not start with',
        fieldTypes: [Models.SearchSettingValueType.Integer, Models.SearchSettingValueType.Double, Models.SearchSettingValueType.DateTime],
        elementTypes: [Models.SearchSettingElementType.TextWithOperators],
        classAttribute: false
    }
];